import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import SweetAlert from 'sweetalert-react';
import {
  clearRedirection,
  clearErrors,
} from '../actions';
import { history } from '../../history';

class GlobalErrorAndRedirectionListener extends Component {
  constructor(props) {
    super(props);

    this.closeModal = this.closeModal.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.errorMessage !== nextProps.errorMessage) return true;
    if (this.props.redirectTo !== nextProps.redirectTo) return true;

    return false;
  }

  componentDidUpdate() {
    if (!this.props.hasError && this.props.redirectTo) this.redirect();
  }

  redirect() {
    if (!this.props.redirectTo) return;

    history.push(this.props.redirectTo);
    this.props.clearRedirection();
  }

  closeModal() {
    this.props.clearErrors();
    this.redirect();
  }

  render() {
    const [title, ...rest] = (this.props.errorMessage || '').split('. ');
    const text = rest.join('. ');

    return (
      <SweetAlert
        show={this.props.hasError}
        title={title || 'Error'}
        text={text}
        type="error"
        confirmButtonColor="#dd6b55"
        confirmButtonText={this.props.confirmButtonText}
        onEscapeKey={this.closeModal}
        onConfirm={this.closeModal}
      />
    );
  }
}
GlobalErrorAndRedirectionListener.propTypes = {
  errorMessage: PropTypes.string,
  redirectTo: PropTypes.string,
  clearErrors: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  clearRedirection: PropTypes.func.isRequired,
  confirmButtonText: PropTypes.string,
};
GlobalErrorAndRedirectionListener.defaultProps = {
  errorMessage: '',
  redirectTo: '',
  hasError: false,
  confirmButtonText: 'Back to home',
};

const mapStateToProps = state => ({
  errorMessage: state.app.error_message,
  redirectTo: state.app.redirect_to,
  hasError: state.app.error_message && state.app.error_message.length > 0,
  confirmButtonText: state.app.confirmButtonText,
});

const mapDispatchToProps = dispatch => ({
  clearRedirection: () => dispatch(clearRedirection()),
  clearErrors: () => dispatch(clearErrors()),
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalErrorAndRedirectionListener);



// WEBPACK FOOTER //
// ./src/app/components/GlobalErrorAndRedirectionListener.jsx